import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { AuthHelpers } from '@eview/core/auth';
import { Permission } from '@eview/core/auth/permission';
import { Post } from '@eview/core/domain/post/post';
import {
  PostComment,
  PostComments,
  PostCommentType
} from '@eview/core/domain/post/post-comment';
import { PostService } from '@eview/core/domain/post/post.service';
import { AppState } from '@eview/core/store/states/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CreatedPostComment, ECustomActions } from '../../custom.store';
import { User } from '@eview/core/models/user';

const ROLE_PRO_USER: string = 'prouser';

@Component({
  selector: 'eview-post-comments',
  templateUrl: 'post-comments.component.html',
  styleUrls: ['post-comments.component.scss']
})
export class PostCommentsComponent implements OnInit, OnChanges, OnDestroy {
  constructor(
    public store: Store<AppState>,
    private action$: Actions,
    private postService: PostService
  ) {
    this.subs = new Subscription();
  }

  @Input() post: Post;
  @Input() type: PostCommentType;
  @Input() user: User;
  @Input() isEditing: Boolean;

  ROLE_PRO_USER = ROLE_PRO_USER;

  comments: PostComments;
  Permission = Permission;
  AuthHelpers = AuthHelpers;
  private subs: Subscription;

  ngOnInit() {
    this.subs.add(
      this.action$
        .pipe(ofType<CreatedPostComment>(ECustomActions.CreatedPostComment))
        .subscribe(() => {
          this.load();
        })
    );
  }

  ngOnChanges() {
    if (!this.isEditing && this.user) {
      this.load();
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  get postFormId(): number | null {
    if (!this.post) {
      return null;
    }
    const fromPost =
      (this.post as any).form_id ??
      this.post.form?.id ??
      (this.post as any).formId;
    return fromPost != null ? Number(fromPost) : null;
  }

  get label(): string {
    switch (this.type) {
      case PostCommentType.Response:
        return 'POST_COMMENT_RESPONSES';
      case PostCommentType.AfterActionReport:
        return 'POST_COMMENT_AFTER_ACTION_REPORT';
    }
    return null;
  }

  load() {
    if (!this.user || !this.post) {
      return;
    }
    this.postService
      .listComments(
        this.post.parent ? this.post.parent.id : this.post.id,
        this.type
      )
      .subscribe(comments => (this.comments = comments));
  }

  onAddClick() {
    this.comments.results = [
      {
        id: 0,
        post_id: this.post.id,
        content: null,
        action_taken: false,
        type: this.type,
        linked_reports: []
      } as PostComment,
      ...this.comments.results
    ];
  }

  onRefreshClick() {
    this.load();
  }
}
